import axios from "axios";

const jaredClient = axios.create({
  baseURL: process.env.REACT_APP_JARED_URL
});

export default jaredClient;
